import { SessionDetails } from '@libs/shared/interfaces/auth';

export const CORE_EVENT_LOGIN = 'CORE_EVENT_LOGIN';
export const CORE_EVENT_LOGOUT = 'CORE_EVENT_LOGOUT';
export const CORE_EVENT_SESSION_DETAILS = 'CORE_EVENT_SESSION_DETAILS';
export const CORE_EVENT_CONTEXT_USER_DETAILS = 'CORE_EVENT_CONTEXT_USER_DETAILS';
export const CORE_EVENT_POUCH_PROBLEM = 'CORE_EVENT_POUCH_PROBLEM';

export interface CoreEventLoginData {
  sessionDetails: SessionDetails;
}

export interface CoreEventLogoutData {
  logout: boolean;
  redirect?: string;
}

export interface CoreEventContextUserDetails {
  contextUserId?: string;
}

export interface CoreEventPouchProblemData {
  error: any;
  message: string;
  pouchStatus: {
    isCreating: boolean;
    isSyncingInitially: boolean;
    isSynced: boolean;
    isReady: boolean;
  };
}
